export default "__VITE_ASSET__b6ce40af__"